import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

import Header from '../../components/header/Header';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import ConditionalLink from '../../components/shared/ConditionalLink';
import PopupBox from '../../components/shared/PopupBox';
import { formatDate, getContrastYIQ } from '../../utilities/Generic.js'
import CreateWeeklyShifts from '../../components/staff-fulfilment/CreateWeeklyShifts';
import UpdateWeeklyShifts from '../../components/staff-fulfilment/UpdateWeeklyShifts';
import PersonForm from '../../forms/Person';
import HolidayForm from '../../forms/Holidays';
import SicknessForm from '../../forms/Sicknesses';
import StaffFulfilmentConfigurationIndex from '../../components/staff-fulfilment/StaffFulfilmentConfigurationIndex';
import ModalContainerTrigger from '../../components/shared/ModalContainerTrigger'
import Flow from '../../components/staff-fulfilment/Flow';

import SlidingPane from "../../components/shared/ScrollableSlidingPane";

class WeeklyShiftsByPerson extends Component {
  constructor(props) {
    super(props);

    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.handleEditPanel = this.handleEditPanel.bind(this);
    this.closeNewPanel = this.closeNewPanel.bind(this);
    this.closeEditPanel = this.closeEditPanel.bind(this);
    this.handlePersonEditPanel = this.handlePersonEditPanel.bind(this);
    this.closePersonEditPanel = this.closePersonEditPanel.bind(this);
    this.handleAbsencePanel = this.handleAbsencePanel.bind(this);
    this.closeAbsencePanel = this.closeAbsencePanel.bind(this);

    this.handleJumpToDate = this.handleJumpToDate.bind(this);
    this.handleJumpToDateTooltip = this.handleJumpToDateTooltip.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePreviousWeek = this.handlePreviousWeek.bind(this);
    this.handleNextWeek = this.handleNextWeek.bind(this);
    this.handlePreviousDay = this.handlePreviousDay.bind(this);
    this.handleNextDay = this.handleNextDay.bind(this);

    this.grabData = this.grabData.bind(this);
  }

  state = {
    workStartsAt: 0,
    durationInHours: 24,

    date: new Date(new Date().toDateString()),
    previouslyGrabbedDateFrom: new Date(new Date().toDateString()),
    jumpToDate: false,
    jumpToDateTooltip: false,

    holidayId: null,
    holidayPersonId: null,
    sicknessId: null,
    sicknessPersonId: null,
    personEditId: null,

    editId: null,
    clickedRole: null,
    clickedDayOfWeek: null,
    clickedHour: null,
    clickedPerson: null,
    newPanelToggle: false,
    editPanelToggle: false,

    rotaLoaded: false,
    rolesLoaded: false,
    shiftsLoaded: false,
    staffHoursByDayLoaded: false,
    staffHolidaysLoaded: false,
    staffSicknessesLoaded: false,

    roles: null,
    shifts: null,
    staff_hours_by_day: null,
    staff_holidays: null,
    staff_sicknesses: null,

    previousParams: this.props.location.search
  }

  handleDateChange(event) {
    const value = event.target.value;
    if (value.length > 0) {
      const date = new Date(value)

      this.setState({
        date: date,
        jumpToDate: false,
        jumpToDateTooltip: false,
        key: Math.random()
      })

      if (this.props.match.params.rota_id !== undefined) {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person?date=${this.formatDate(date)}`);
      }
      else {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person?date=${this.formatDate(date)}`);
      }

      this.grabData(date)
    }
  }

  handlePreviousWeek(event) {
    this.setState(prevState => {
      const newDate = new Date(prevState.date)
      newDate.setDate(newDate.getDate() - 7)

      if (this.props.match.params.rota_id !== undefined) {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }
      else {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }

      return ({
        date: newDate
      })
    })
  }

  handleNextWeek(event) {
    this.setState(prevState => {
      const newDate = new Date(prevState.date)
      newDate.setDate(newDate.getDate() + 7)

      if (this.props.match.params.rota_id !== undefined) {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }
      else {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }

      return ({
        date: newDate
      })
    })
  }

  handlePreviousDay(event) {
    this.setState(prevState => {
      const newDate = new Date(prevState.date)
      newDate.setDate(newDate.getDate() - 1)

      if (this.props.match.params.rota_id !== undefined) {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }
      else {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }

      return ({
        date: newDate
      })
    })
  }

  handleNextDay(event) {
    this.setState(prevState => {
      const newDate = new Date(prevState.date)
      newDate.setDate(newDate.getDate() + 1)

      if (this.props.match.params.rota_id !== undefined) {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }
      else {
        this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person?date=${this.formatDate(newDate)}`);
      }

      return ({
        date: newDate
      })
    })

  }

  formatDate(date) {
    const day = ("0" + (date.getDate())).slice(-2)
    const month = ("0" + (date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()

    return `${year}-${month}-${day}`
  }

  handleJumpToDate(event) {
    this.setState({jumpToDate: true})

    event.preventDefault();
  }

  handleJumpToDateTooltip(event) {
    if (event.target.value.length > 0) {
      this.setState({jumpToDateTooltip: true})
    }
    else {
      this.setState({jumpToDateTooltip: false})
    }
    event.preventDefault();
  }

  handleNewPanel(event) {
    const clickedRole = event.currentTarget.dataset.role_id;
    const clickedStartDate = event.currentTarget.dataset.start_date
    const clickedHour = event.currentTarget.dataset.start_hour

    const role = this.state.roles.find(role => role.id === parseInt(clickedRole))
    const personHeight = event.target.offsetHeight / role.people.length
    const clickedPerson = role.people[(Math.floor(event.nativeEvent.layerY / personHeight))].id

    this.setState({
      newPanelToggle: true,
      clickedRole: clickedRole,
      clickedStartDate: clickedStartDate,
      clickedHour: clickedHour,
      clickedPerson: clickedPerson,
      previousParams: this.props.location.search
    });

    if (this.props.match.params.rota_id !== undefined) {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person/new`)
    }
    else {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person/new`)
    }

    event.stopPropagation();
  }

  handleEditPanel(event) {
    var id = event.currentTarget.id;

    this.setState({
      editId: id,
      editPanelToggle: true,
      previousParams: this.props.location.search
    });

    if (this.props.match.params.rota_id !== undefined) {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person/${id}`)
    }
    else {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person/${id}`)
    }

    event.stopPropagation();
  }

  closeNewPanel() {
    this.setState({
      newPanelToggle: false,
      clickedRole: null,
      clickedDayOfWeek: null,
      clickedHour: null,
      clickedPerson: null
    });

    if (this.props.match.params.rota_id !== undefined) {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person${this.state.previousParams}`)
    }
    else {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person${this.state.previousParams}`)
    }

    this.grabData(this.state.date);
  }

  closeEditPanel() {
    this.setState({
      editPanelToggle: false,
      editId: null
    });

    if (this.props.match.params.rota_id !== undefined) {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person${this.state.previousParams}`)
    }
    else {
      this.props.history.push(`/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person${this.state.previousParams}`)
    }

    this.grabData(this.state.date);
  }

  handlePersonEditPanel(event) {
    var id = event.currentTarget.id;

    this.setState({ personEditId: id })
  }

  closePersonEditPanel() {
    this.setState({ personEditId: null })
    this.componentDidMount()
  }

  handleAbsencePanel(event) {
    const id = event.currentTarget.id;
    const personId = event.currentTarget.dataset.person_id;
    const type = event.currentTarget.dataset.type;

    this.setState({
      [type+ "Id"]: id,
      [type + "PersonId"]: personId
    })
  }

  closeAbsencePanel() {
    this.setState({
      holidayId: null,
      sicknessId: null,
    })
    this.componentDidMount()
  }

  renderDateSelect() {
    if (this.state.location !== "") {
      const hidden = this.state.jumpToDate ? "" : "hidden "
      return (
        <>
          <div className="small button" onClick={this.handleJumpToDate}>Jump to Date:</div>
          <div className="jump-to-date-tooltip-container">
            <input className={hidden + "contextual-date"} type="date" name="date" onChange={this.handleJumpToDateTooltip} onBlur={this.handleDateChange} />
            {this.renderJumpToDateTooltip()}
          </div>
        </>
      )
    }
  }

  renderJumpToDateTooltip() {
    if (this.state.jumpToDateTooltip) {
      return (
        <div className="jump-to-date-tooltip">Click away from the Date selector to confirm your pick when ready.</div>
      )
    }
  }

  renderRotaName() {
    if (this.state.rota === undefined) {
      return
    }
    else {
      return (
        <>
         - {this.state.rota.name} Rota
        </>
      )
    }
  }

  render() {
    const { match: { params } } = this.props;
    const { workStartsAt, durationInHours, clickedStartDate, clickedRole, clickedHour, clickedPerson, editId, rolesLoaded, shiftsLoaded, rotaLoaded, staffHolidaysLoaded, unauthorized, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (rolesLoaded === false || shiftsLoaded === false || rotaLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (rolesLoaded && shiftsLoaded && rotaLoaded && staffHolidaysLoaded) {
      return (
        <div className="fulfilment">
          <SetTitle title={"Staff Fulfilment"} />
          <PopupBox />
          <Header />

          <div className="main-page">
            <h2 className="page-title">Staff Fulfilment {this.renderRotaName()}</h2>
            <OrganisationName />

            <Flow location_id={params.location_id} rota_id={params.rota_id} schedule="weekly" coverage="shifts" view="person" page={"Assigned Shifts by Person"} />

            <div>
              {this.renderDateSelect()}
              <div className="small button" onClick={this.handlePreviousWeek}>Previous Week</div>
              <div className="small button" onClick={this.handleNextWeek}>Next Week</div>
              <div className="small button" onClick={this.handlePreviousDay}>Previous Day</div>
              <div className="small button" onClick={this.handleNextDay}>Next Day</div>

              {this.renderDailyRotas()}
            </div>
          </div>

          <ModalContainerTrigger triggerText="Template configuration" className="small button right config">
            <StaffFulfilmentConfigurationIndex location_id={params.location_id} />
          </ModalContainerTrigger>

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Weekly Shift" width="60%"
            onRequestClose={this.closeNewPanel}>
            <CreateWeeklyShifts origin="working-pattern" workStartsAt={workStartsAt} dayDuration={durationInHours} clickedHour={clickedHour} start_date={clickedStartDate} role_id={clickedRole} clickedPerson={clickedPerson} location_id={params.location_id} closeNewPanel={this.closeNewPanel} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.editPanelToggle} title="Edit Weekly Shift" width="60%"
            onRequestClose={this.closeEditPanel}>
            <UpdateWeeklyShifts id={editId} closeEditPanel={this.closeEditPanel} workStartsAt={workStartsAt} dayDuration={durationInHours} location_id={params.location_id} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.personEditId !== null} title="Edit Person" width="60%"
            onRequestClose={this.closePersonEditPanel}>
            <PersonForm mode="update" id={this.state.personEditId} closeEditPanel={this.closePersonEditPanel} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.holidayId !== null} title="Edit Holiday" width="60%"
            onRequestClose={this.closeAbsencePanel}>
            <HolidayForm mode="update" id={this.state.holidayId} person_id={this.state.holidayPersonId} closePanel={this.closeAbsencePanel} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.sicknessId !== null} title="Edit Sickness" width="60%"
            onRequestClose={this.closeAbsencePanel}>
            <SicknessForm mode="update" id={this.state.sicknessId} person_id={this.state.sicknessPersonId} closePanel={this.closeAbsencePanel} />
          </SlidingPane>
        </div>
      );
    }
  }

  renderDailyRotas() {
    let dates = []
    const firstDay = this.state.date;

    for (let i = 0; i < 7; i++) {
      const date = new Date(firstDay);
      date.setDate(firstDay.getDate() + i);

      dates.push(date)
    }

    return (
      <div className="rotas">
        {dates.map((date) => (
          this.renderIndividualDay(date)
        ))}
      </div>
    )
  }

  calculatePercentage() {
    const currentDate = new Date().toLocaleTimeString()

    const hour = parseInt(currentDate.split(":")[0])
    const minute = parseInt(currentDate.split(":")[1])

    const totalMinutes = 23 * 60 + 59;
    const currentMinutes = hour * 60 + minute;
    const percentage = 20.58 + ((currentMinutes / totalMinutes) * (97.83 - 20.58));

    return parseFloat(percentage.toFixed(2));
  }

  calculatePPF(date) {
    var currentDate = new Date();
    var inputDate = new Date(date);

    currentDate.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate < currentDate) return "past"
    if (inputDate > currentDate) return "future"

    return "present"
  }

  renderIndividualDay(date) {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const day = daysOfWeek[date.getDay()]

    const { workStartsAt, durationInHours } = this.state;
    const workingHours = Array.from({length: durationInHours}, (_, i) => workStartsAt + i);

    let backgroundStyle = {}
    const backgroundClass = this.calculatePPF(date) // "past", "present", or "future"

    if (backgroundClass === "present") {
      const percentage = this.calculatePercentage();

      backgroundStyle = { background: `linear-gradient(to right, #cfcfcf ${percentage}%, #f00 ${percentage}%, #f00 ${percentage + 0.25}%, #eee 0%)` }
    }

    const roles = this.state.roles;

    return (
      <div key={date} className={`container ${backgroundClass}`} style={backgroundStyle}>
        <div className="graph">

          {/* Header */}
          <div className="roles with-people">
            <div className="left">
              <div className="role-label">People</div>
            </div>
            <div className="right">
              <div className="title">{day} {date.getDate()}/{date.getMonth() + 1}/{date.getFullYear()}</div>
              <div className="hours" style={{gridTemplateColumns: `repeat(${workingHours.length}, 1fr)`}}>
                {workingHours.map((hour, index) => (
                  <div key={hour} className="hour-title">{hour}</div>
                ))}
              </div>
            </div>
          </div>

          {roles.map((role) => (
            this.renderIndividualRole(role, workingHours, date)
          ))}
        </div>
      </div>
    )
  }

  renderIndividualRole(role, workingHours, date) {
    let weekNumberMessage;

    if (this.state.rotaConfigurationsLoaded) {
      const today = new Date(date)
      today.setHours(0)
      today.setMinutes(0)
      today.setSeconds(0)
      today.setMilliseconds(0)

      const start_of_current_period = new Date(this.state.rota_configurations[role.id].start_of_current_period)

      const default_period = this.state.rota_configurations[role.id].default_period_weeks * 7

      // Convert millisecond difference into days (86400000 === 1000 * 60 * 60 * 24))
      const currentDay = (Math.round((today - start_of_current_period) / 86400000)) % default_period

      weekNumberMessage = `Week ${Math.floor(currentDay / 7) + 1} of ${this.state.rota_configurations[role.id].default_period_weeks}`
    }

    let shiftsToday = this.state.shifts[role.id] && this.state.shifts[role.id].filter(shift => (new Date(shift.start_date).toDateString() === date.toDateString() || new Date(shift.end_date).toDateString() === date.toDateString())) // day_of_week will need to be <= shift.start_day_of_week and >= shift.end_day_of_week
    let holidaysToday = (this.state.staff_holidays && this.state.staff_holidays.filter(holiday => (new Date(holiday.start_date).toDateString() === date.toDateString() || new Date(holiday.end_date).toDateString() === date.toDateString() || (date >= new Date(holiday.start_date) && date <= new Date(holiday.end_date))))) || []
    let sicknessesToday = (this.state.staff_sicknesses && this.state.staff_sicknesses.filter(sickness => (new Date(sickness.start_time).toDateString() === date.toDateString() || new Date(sickness.end_time).toDateString() === date.toDateString() || (date >= new Date(sickness.start_time) && date <= new Date(sickness.end_time))))) || []

    let shiftsTodayByPerson = (shiftsToday && Object.groupBy(shiftsToday, ({person_id}) => person_id)) || []
    let holidaysTodayByPerson = (holidaysToday && Object.groupBy(holidaysToday, ({person_id}) => person_id)) || []
    let sicknessesTodayByPerson = (sicknessesToday && Object.groupBy(sicknessesToday, ({person_id}) => person_id)) || []

    return (
      <div className="roles with-people" key={`role${role.id}`}>
        <div className="left">
          <div className="role-title-container">
            <div className="role-title sideways">
              <div className="bubble" style={{ backgroundColor: role.color, color: getContrastYIQ(role.color)}}>{role.name}</div>
              {this.state.rotaConfigurationsLoaded &&
                <div className="hour-count">{weekNumberMessage}</div>
              }
            </div>
          </div>
          <div className="row-labels" style={{gridTemplateRows: `repeat(${role.people.length}, 1fr)`}}>
            {role.people.map((person) =>
              <div key={person.id} id={person.id} onClick={this.handlePersonEditPanel} className="clickable label">
                {this.renderPersonName(person)}
                {this.renderRotaVsContractedHours(person, date)}
              </div>
            )}
          </div>
        </div>
        <div className="right">
          <div className="assigned-hours">
            {role.people.map((person, index) => (
              <React.Fragment key={person.id}>
                {this.renderShiftsByPerson(shiftsTodayByPerson[person.id], date, index, role.people.length, role.color)}
                {this.renderAbsencesByPerson(holidaysTodayByPerson[person.id], date, index, role.people.length, "holiday")}
                {this.renderAbsencesByPerson(sicknessesTodayByPerson[person.id], date, index, role.people.length, "sickness")}
              </React.Fragment>
            ))}
          </div>
          <div className="hours" style={{gridTemplateColumns: `repeat(${workingHours.length}, 1fr)`}}>
            {workingHours.map(hour => (
              <div className="hour-column" key={hour} onClick={this.handleNewPanel} data-start_hour={`0${hour}:00`.slice(-5)} data-role_id={role.id} data-start_date={formatDate(date)}><wbr/></div>
            ))}
          </div>
        </div>
        <div className="new-shift">
          <div className="plus-button" onClick={this.handleNewPanel} data-start_date={formatDate(date)} data-role_id={role.id}>+</div>
        </div>
      </div>
    )
  }

  renderPersonName(person) {
    let name = person.full_name
    if (name.length > 20) {
      return <div className="person" title={name} key={person.id}>{name.slice(0, 18)}...</div>

    }
    return <div className="person" key={person.id}>{name}</div>
  }

  renderRotaVsContractedHours(person, date) {
    if (this.state.staffHoursByDayLoaded === false) {
      return
    }

    if (this.state.staff_hours_by_day[date.getDate()]) {
      let {tallied_hours, contracted_hours} = this.state.staff_hours_by_day[date.getDate()][person.id];

      let spanClassName = ""
      let context = ""

      if (contracted_hours !== null) {
        context = ` / ${contracted_hours}`

        if (tallied_hours > contracted_hours) {
          spanClassName = "orange-text"
        }

        if (tallied_hours < contracted_hours) {
          spanClassName = "red-text"
        }
      }

      context += " hours"

      return <div className="contracted-hours"><span className={spanClassName}>{tallied_hours}</span>{context}</div>
    }
    else {
      return <div className="contracted-hours"></div>
    }
  }

  renderShiftsByPerson(shiftsByPerson, date, index, number_of_people, role_color) {
    if (!shiftsByPerson) {
      return ""
    }

    return (
      shiftsByPerson.map((shift) => {
        const [startHours, startMinutes] = shift.start_time.split(":").map(Number);
        const [endHours, endMinutes] = shift.end_time.split(":").map(Number);

        let startMinute = startHours * 60 + startMinutes;
        let endMinute = endHours * 60 + endMinutes;

        if (endMinute < startMinute) {
          if (new Date(shift.start_date) < date) {
            startMinute = 0
          }
          else {
            endMinute = 1440
          }
        }

        return (
          <ConditionalLink to={this.shiftURL(shift)} condition={!shift.cool_record} key={shift.id} id={shift.id} title={`Starts at ${shift.start_time}, ends at ${this.minuteToTime(endMinute)}`} style={{ backgroundColor: role_color, clipPath: `polygon(${this.calculateCoordinates(startMinute, endMinute, index, number_of_people)})` }} onClick={this.handleEditPanel}><wbr/></ConditionalLink>
        )
      })
    )
  }

  shiftURL(shift) {
    if (this.props.match.params.rota_id !== undefined) {
      return `/staff-fulfilment/${this.props.match.params.location_id}/rotas/${this.props.match.params.rota_id}/weekly/shifts-by-person/${shift.id}`
    }
    else {
      return `/staff-fulfilment/${this.props.match.params.location_id}/weekly/shifts-by-person/${shift.id}`
    }
  }

  renderAbsencesByPerson(absencesByPerson, date, index, number_of_people, type) {
    if (!absencesByPerson) {
      return null
    }

    return (
      absencesByPerson.map((absence) => {
        let startMinute = 0
        let endMinute = 1440
        let titleStart

        if (type === "sickness") {
          if (new Date(absence.start_time).toDateString() === date.toDateString()) {
            const startTime = absence.start_time.split("T")[1]
            const [startHours, startMinutes] = startTime.split(":").map(Number)
  
            startMinute = startHours * 60 + startMinutes;
          }
  
          if (new Date(absence.end_time).toDateString() === date.toDateString()) {
            const endTime = absence.end_time.split("T")[1]
            const [endHours, endMinutes] = endTime.split(":").map(Number)
  
            endMinute = endHours * 60 + endMinutes;
          }

          titleStart = absence.start_time
        }
        else {
          if (new Date(absence.start_date).toDateString() === date.toDateString()) {
            startMinute = absence.half_day_work_at_start ? 721 : startMinute
          }
  
          if (new Date(absence.end_date).toDateString() === date.toDateString()) {
            endMinute = absence.half_day_work_at_end ? 720 : endMinute
          }

          titleStart = absence.start_date
        }

        return (
          <div key={absence.id} id={absence.id} data-person_id={absence.person_id} data-type={type} title={`Starts at ${titleStart}, ends at ${this.minuteToTime(endMinute)}`} style={{ backgroundColor: this.absenceBackgroundColor(type), clipPath: `polygon(${this.calculateCoordinates(startMinute, endMinute, index, number_of_people)})` }} onClick={this.handleAbsencePanel}><wbr/></div>
        )
      })
    )
  }

  absenceBackgroundColor(type) {
    const lookup = {
      holiday: "purple",
      sickness: "grey"
    }

    return lookup[type]
  }

  minuteToTime(minute) {
    return `${("0" + Math.floor(minute/60)).slice(-2)}:${("0" + minute % 60).slice(-2)}`
  }

  calculateCoordinates(startMinute, endMinute, index, number_of_people) {
    const graphStartRange = this.state.workStartsAt * 60
    const graphEndRange = graphStartRange + (this.state.durationInHours * 60)

    const startPercentage = ((startMinute - graphStartRange) / (graphEndRange - graphStartRange)) * 100;
    const endPercentage = ((endMinute - graphStartRange) / (graphEndRange - graphStartRange)) * 100;

    const topOfArea = 100 / number_of_people * index
    const bottomOfArea = (100 / number_of_people) * (index + 1)

    const spacing = (bottomOfArea - topOfArea) / 3
    const blockHeight = topOfArea + spacing
    const bottomOfBlock =  bottomOfArea - spacing

    let points = []

    points.push(`${startPercentage}% ${bottomOfBlock}%`)
    points.push(`${startPercentage}% ${blockHeight}%`)
    points.push(`${endPercentage}% ${blockHeight}%`)
    points.push(`${endPercentage}% ${bottomOfBlock}%`)

    // Important note for debugging:
    //
    // The CSS attribute clip-path that we use to drive this feature has a wonky axis.
    //
    // If the calculations seem surprising, this is why:
    //
    //      0%                   100%
    //   0% ┌───────────────────────┐ 0%
    //      │                       │
    //      │                       │
    //    Y │                       │
    //    - │                       │
    //    a │                       │
    //    x │                       │
    //    i │                       │
    //    s │                       │
    //      │                       │
    //      │                       │
    // 100% └───────────────────────┘ 100%
    //      0%        X-axis      100%
    //

    return points
  }

  static getDerivedStateFromProps(props, state) {
    const id = props.match.params.id
    if (state.newPanelToggle && id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        editId: id
      }
    }
    else if (state.editPanelToggle && id === undefined) {
      return {
        editPanelToggle: false
      }
    }
    else if (state.editPanelToggle && id !== state.editId) {
      return {
        editId: id
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith("/weekly/shifts-by-person")) {
      return {
        newPanelToggle: false,
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/new")) {
      return {
        newPanelToggle: true,
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        editId: id
      }
    }
    else {
      return null
    }
  }

  grabData(date) {
    this.setState({
      previouslyGrabbedDateFrom: date
    })

    const dateFrom = date
    const dateTo = new Date(dateFrom)
    dateTo.setDate(dateFrom.getDate() + 7);

    const location_id = this.props.match.params.location_id
    const rota_id = this.props.match.params.rota_id

    let queryString = `location_id=${location_id}`

    if (rota_id !== undefined) {
      queryString += `&rota_id=${rota_id}`
    }

    request('GET', `/v1/a/weekly_shift_assignments?${queryString}&date_from=${this.formatDate(dateFrom)}&date_to=${this.formatDate(dateTo)}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ shifts: data, shiftsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, shiftsLoaded: true })
      })

    request('GET', `/v1/a/staff_fulfilment/weekly_rota_configurations?${queryString}&date_from=${this.formatDate(dateFrom)}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ rota_configurations: data, rotaConfigurationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, rotaConfigurationsLoaded: true })
      })

    request('GET', `/v1/a/staff_fulfilment/weekly_staff_hours_by_day?${queryString}&date_from=${this.formatDate(dateFrom)}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ staff_hours_by_day: data, staffHoursByDayLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, staffHoursByDayLoaded: true })
      })

    request('GET', `/v1/a/staff_holidays?location_id=${location_id}&date_from=${this.formatDate(dateFrom)}&date_to=${this.formatDate(dateTo)}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ staff_holidays: data, staffHolidaysLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, staffHolidaysLoaded: true })
      })

    request('GET', `/v1/a/staff_sicknesses?location_id=${location_id}&date_from=${this.formatDate(dateFrom)}&date_to=${this.formatDate(dateTo)}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ staff_sicknesses: data, staffSicknessesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, staffSicknessesLoaded: true })
      })
  }

  componentDidMount() {
    let date = new Date()

    if (this.props.location.search !== "") {
      const params = new URLSearchParams(this.props.location.search)
      if (params.get('date')) {
        date = new Date(params.get('date'))
      }

      this.setState({
        date: date,
        previouslyGrabbedDateFrom: date,
        key: Math.random()
      });
    }

    let queryString = ""
    const rota_id = this.props.match.params.rota_id

    if (rota_id !== undefined) {
      queryString = `?rota_id=${rota_id}`
    }

    request('GET', `/v1/a/locations/${this.props.match.params.location_id}/roles_and_people${queryString}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ roles: data, rolesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, rolesLoaded: true })
      })

    if (rota_id !== undefined) {

      request('GET', `/v1/a/rota_types/${rota_id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({ rota: data, rotaLoaded: true })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, rotaLoaded: true })
        })
    }
    else {
      this.setState({ rotaLoaded: true })
    }

    this.grabData(date)
  }

  componentDidUpdate() {
    if (this.state.date !== this.state.previouslyGrabbedDateFrom) {
      this.grabData(this.state.date)
    }
  }
}

export default WeeklyShiftsByPerson;
